// `Symbol.unscopables` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.unscopables
require('../internals/define-well-known-symbol')('unscopables');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.unscopables.js
// module id = 295
// module chunks = 1